import React, { useState } from "react";
import ManageExpertProfile from "./ManageExpertProfile/ManageExpertProfile";
import { useSelector } from "react-redux";
import ProfileSettings from "./ProfileSettings/ProfileSettings";

export default function UpdateProfile() {
  const [formData, setFormData] = useState("");
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);
  return (
    <div>
      {profile?.role_type == 2 ? (
        <ProfileSettings
          formData={formData}
          setFormData={setFormData}
          edittype={1}
        />
      ) : (
        <ManageExpertProfile
          formData={formData}
          setFormData={setFormData}
          edittype={1}
        />
      )}
    </div>
  );
}
